import { SessionData } from 'react-router';
import { TFunction } from 'i18next';
import { getCookie } from './cookies';

/**
 * Delete File Exported Legacy
 * Updates the exports of the logged-in user as Inactive and Hidden
 */
export async function deleteFileExported(t: TFunction): Promise<any> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 segundos

    try {
        const response = await fetch('/Classes/Layout/Session.server.php', {
            method: 'POST',
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded;charset=UTF-8',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: 'action=__delete_file_exported',
            signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok && response.statusText !== 'OK') {
            throw new Error(t('messages.error'));
        }
    } catch (error) {
        clearTimeout(timeoutId);
        throw error;
    }
}

export async function saveFileExported(
    id_export: number,
    t: TFunction
): Promise<any> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 segundos

    try {
        const response = await fetch('/Classes/Layout/Session.server.php', {
            method: 'POST',
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded;charset=UTF-8',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: `action=__save_file_exported&id_export=${id_export}`,
            signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok && response.statusText !== 'OK') {
            throw new Error(t('messages.error'));
        }
    } catch (error) {
        clearTimeout(timeoutId);
        throw error;
    }
}

/**
 * End Session
 * Ends the current user session by redirecting to the logout URL.
 * This function does not return any value.
 * It is used to log out the user and clean up the session.
 */
export async function endSession(t: TFunction): Promise<any> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 segundos

    try {
        const response = await fetch('/Classes/Layout/Session.server.php', {
            method: 'POST',
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded;charset=UTF-8',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: 'action=__end_session',
            signal: controller.signal,
            // A opção 'cache' pode ser usada no fetch:
            // Valores possíveis: 'default', 'no-store', 'reload', 'no-cache', 'force-cache', 'only-if-cached'
            // Exemplo:
            cache: 'no-store',
        });

        clearTimeout(timeoutId);

        if (!response.ok && response.statusText !== 'OK') {
            throw new Error(t('messages.error'));
        }

        let data = null;
        if (response.ok && !response.redirected) {
            data = await response.json();

            if (data.url_redirect) {
                window.location.href = data.url_redirect;
            } else {
                window.location.href = '/Login/';
            }
        }
    } catch (error) {
        clearTimeout(timeoutId);
        throw error;
    }
}

let refreshTokenPromise: undefined | Promise<string | undefined>;
export const callRefreshToken = async (): Promise<string | undefined> => {
    if (!refreshTokenPromise) {
        refreshTokenPromise = new Promise((resolve, reject) => {
            fetch('/Common/token/refresh/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            })
                .then(async (response) => {
                    if (!response.ok) {
                        return reject(new Error('Failed to refresh token'));
                    }
                    const data = await response.json();

                    const session: SessionData = JSON.parse(
                        atob(getCookie('__session'))
                    );
                    session.token = data.accessToken;
                    const newSessionString = btoa(JSON.stringify(session));
                    document.cookie = `__session=${newSessionString};path=/`;

                    return resolve(data.accessToken);
                })
                .catch(reject)
                .finally(() => {
                    refreshTokenPromise = undefined;
                });
        });
    }
    return refreshTokenPromise;
};
